module.exports = __webpack_public_path__ + "img/7e5ff40.png";